import { Link } from 'react-router-dom';

/**
 * One rendering of a gateway instance: id plus fleet region.
 * Used on the matrix, traffic table, decision tree, and node page.
 */
export function NodeIdentity({
  nodeId,
  region,
  to,
  testId,
}: {
  readonly nodeId: string;
  readonly region: string;
  readonly to?: string;
  readonly testId?: string;
}): JSX.Element {
  const label = (
    <>
      <span className="font-mono text-dense">{nodeId}</span>
      <span className="ml-2 font-mono text-micro uppercase text-paper-low">{region}</span>
    </>
  );
  if (to !== undefined) {
    return (
      <Link
        to={to}
        className="text-signal hover:underline"
        data-testid={testId}
      >
        {label}
      </Link>
    );
  }
  return (
    <span data-testid={testId}>
      {label}
    </span>
  );
}
